// Get all button-image-container elements
const containers = document.querySelectorAll('.button-image-container');

// Attach click event handlers to all anchor tags in each container
containers.forEach(container => {
    // Get the anchor tags and image container for the current container
    const anchors = container.querySelectorAll('.button-container a');
    const image = container.querySelector('.image-container img');

    // Set the first anchor to be active by default and display its image
    const defaultAnchor = anchors[0];
    defaultAnchor.classList.add('active');
    image.src = defaultAnchor.getAttribute('data-image');
    image.alt = defaultAnchor.getAttribute('data-alt');

    anchors.forEach(anchor => {
        anchor.addEventListener('click', function () {
            // Get the image source and alt text from the data attributes of the clicked anchor
            const imgSrc = anchor.getAttribute('data-image');
            const imgAlt = anchor.getAttribute('data-alt');

            // Remove the "active" class from all anchors in the same container
            anchors.forEach(a => a.classList.remove('active'));
            // Add the "active" class to the clicked anchor
            anchor.classList.add('active');

            // Update the image source and alt text in the same container
            image.src = imgSrc;
            image.alt = imgAlt;
        });
    });
});




